module.exports = __webpack_public_path__ + "static/media/news-activity-img1.4590bf73.png";